import { BaseService } from './base.service';
import { CustomResponseEntity } from '../types/common';
import { MeasurementTypeDto } from '../types/dtos/program';
import { PaginationParams } from '../types/common';

export class MeasurementTypeService extends BaseService<MeasurementTypeDto> {
  constructor() {
    super('/api/v1/measurement-types');
  }

  findAll(params?: PaginationParams & { isActive?: boolean }): Promise<CustomResponseEntity<MeasurementTypeDto[]>> {
    return super.findAll(params);
  }
}

export const measurementTypeService = new MeasurementTypeService();

